type NostoContentPlacement = {
    html?: string;
    result_id?: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

export function getNostoContentPlacement(
    response: unknown,
    placementIdentifier: string
): NostoContentPlacement | undefined {
    if (!isRecord(response)) return undefined;

    const campaigns = isRecord(response.campaigns) ? response.campaigns : {};
    const content = isRecord(campaigns.content) ? campaigns.content : {};
    const recommendations = isRecord(response.recommendations)
        ? response.recommendations
        : {};
    // Session API responses can group content campaigns or expose legacy recommendations.
    const placement =
        content[placementIdentifier] ?? recommendations[placementIdentifier];
    if (!isRecord(placement)) return undefined;

    return {
        html: typeof placement.html === 'string' ? placement.html : undefined,
        result_id:
            typeof placement.result_id === 'string'
                ? placement.result_id
                : undefined,
    };
}

export function recordNostoContentClick(
    campaignId: string | null | undefined
): void {
    if (typeof window === 'undefined') return;
    if (!campaignId) {
        console.warn(
            '[Nosto] Cannot attribute content click without a campaign result_id.'
        );
        return;
    }
    if (typeof window.nostojs !== 'function') {
        console.warn(
            '[Nosto] Cannot attribute content click: JS API is unavailable.'
        );
        return;
    }

    window.nostojs((api) => {
        api.recordAttribution({
            type: 'con',
            target: campaignId,
            refType: 'oc',
        }).done();
    });
}
